import { Auth } from "aws-amplify"

export const getAccessToken = async () => {
  return (await Auth.currentSession())?.getIdToken()?.getJwtToken()
}
export const getRefreshToken = async () => {
  return (await Auth.currentSession())?.getRefreshToken()?.getToken()
}
